import { ArrowLeft } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ViewportSize } from "../../types";
import { renderIcon } from "../../utils/icons";
import Button from "./Button";

interface ToolbarProps {
    viewportSize: ViewportSize;
    setViewportSize: (size: ViewportSize) => void;
    canUndo: boolean;
    canRedo: boolean;
    onUndo: () => void;
    onRedo: () => void;
    onPublish: () => void;
    onPreview: () => void;
    onImport: () => void;
}

const Toolbar: React.FC<ToolbarProps> = ({
    viewportSize,
    setViewportSize,
    canUndo,
    canRedo,
    onUndo,
    onRedo,
    onPublish,
    onPreview,
    onImport,
}) => {
    const navigate = useNavigate();

    return (
        <div className="fixed top-0 left-0 right-0 bg-white border-b h-14 flex items-center px-4 z-10">
            <div className="flex items-center gap-2">
                {/* Back Button */}
                <button
                    onClick={() => navigate('/custom-headers/v2/')}
                    className="flex items-center text-gray-600 hover:text-gray-900"
                >
                    <ArrowLeft className="w-4 h-4 mr-1" />
                    Back
                </button>

                <button
                    className="p-2 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                    onClick={onUndo}
                    disabled={!canUndo}>
                    ↩️
                </button>
                <button
                    className="p-2 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                    onClick={onRedo}
                    disabled={!canRedo}>
                    ↪️
                </button>
                <div className="ml-4 border-l pl-4">
                    <h1 className="text-lg font-semibold">
                        Header Design Builder
                    </h1>
                </div>
            </div>

            <div className="ml-auto flex items-center gap-2">
                <Button
                    variant="outline"
                    size="md"
                    className="mr-2"
                    onClick={onImport}
                    icon={renderIcon("upload", 16)}>
                    Import
                </Button>
                <Button
                    variant="outline"
                    size="md"
                    className="mr-2"
                    onClick={onPreview}
                    icon={renderIcon("eye", 16)}>
                    Preview
                </Button>
                <Button
                    variant="primary"
                    size="md"
                    onClick={onPublish}
                    icon={renderIcon("code", 16)}>
                    Publish
                </Button>
                <button
                    className={`p-2 rounded hover:bg-gray-100 ${viewportSize === "desktop" ? "text-blue-500" : ""
                        }`}
                    onClick={() => setViewportSize("desktop")}>
                    💻
                </button>
                <button
                    className={`p-2 rounded hover:bg-gray-100 ${viewportSize === "tablet" ? "text-blue-500" : ""
                        }`}
                    onClick={() => setViewportSize("tablet")}>
                    📱
                </button>
                <button
                    className={`p-2 rounded hover:bg-gray-100 ${viewportSize === "mobile" ? "text-blue-500" : ""
                        }`}
                    onClick={() => setViewportSize("mobile")}>
                    📱
                </button>
            </div>
        </div>
    );
};

export default Toolbar;
